module.exports = __webpack_public_path__ + "static/media/sidebar-2.38262d8d.jpg";